// extracted by mini-css-extract-plugin
export default {"mt80":"Team_mt80__PuY5t","bigtitle":"Team_bigtitle__10via","smallTitle":"Team_smallTitle__W+8ip"};